import { ControlPosition, Map } from 'shared/map-exports';
import { useTranslation } from 'react-i18next';

import MapLegendIcon from 'assets/map_legend.svg?react';
import { useMapGLController } from 'features/mapping/hooks/useMapGLController/useMapGLController';
import { MapControlButton } from '../MapControlButton';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
} from '../BaseMapboxGLController';

type LegendControlProps = {
  setDrawerOpen: () => void;
  position?: ControlPosition | undefined;
};

const LegendControlContent = (props: LegendControlProps): JSX.Element => {
  const { setDrawerOpen } = props;
  const { t } = useTranslation();

  return (
    <MapControlButton
      text={t('map.controls.legend')}
      Icon={MapLegendIcon}
      onClick={setDrawerOpen}
    />
  );
};

class MapboxGLLegendController extends BaseMapboxGLController<
  LegendControlProps & BaseMapboxGLControllerProps & { map?: Map }
> {
  content = (): JSX.Element => (
    <LegendControlContent map={this.map} {...this.props} />
  );
}

export const LegendControl = (props: LegendControlProps): null => {
  useMapGLController(props, MapboxGLLegendController);
  return null;
};
